import { useQuery } from '@tanstack/react-query'
import { fetchDepartments } from '@/services/httpServices/departmentService'

/** Departments for the public website appointment form. */
export function useDepartments() {
  return useQuery({
    queryKey: ['departments'],
    queryFn: fetchDepartments,
    staleTime: 5 * 60 * 1000,
  })
}
